<template>
  <div class="coupon-edit-wrap">
    <el-card class="coupon-edit-body">
      <div style="margin-left:20px;margin-bottom:30px" v-if="!this.$route.params.id">
        <template>
          <el-radio-group v-model="type" @change="typeChange">
            <el-radio label="1">通用券</el-radio>
            <el-radio label="2">门店券</el-radio>
          </el-radio-group>
        </template>
      </div>
      <!-- 通用卷 -->
      <el-row>
        <el-col>
          <el-form label-width="110px" ref="couponForm" :model="couponData" :rules="rules">
            <el-form-item label="优惠券名称" prop="name">
              <el-col :span="10">
                <el-input v-model="couponData.name"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="优惠券面额" prop="denomination">
              <el-col :span="10" class="mr10">
                <el-input
                  v-model="couponData.denomination"
                  @keyup.native="checkNumber('denomination')"
                ></el-input>
              </el-col>
              <el-col :span="10">元</el-col>
            </el-form-item>
            <el-form-item label="兑换所需积分" prop="score">
              <el-col :span="10">
                <el-input v-model="couponData.score" @keyup.native="checkNumber('score')"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="有效期" prop="valid_day">
              <el-col :span="10" class="mr10">
                <el-input v-model="couponData.valid_day" @keyup.native="checkNumber('valid_day')"></el-input>
              </el-col>
              <el-col :span="10">天</el-col>
            </el-form-item>
            <el-form-item label="上传图片" prop="img">
              <!-- :listType="'picture-card'" -->
              <!-- fileList  -->
              <div style="width:200px;height:200px;position:relative" v-if="couponData.img">
                <i
                  class="el-icon-remove"
                  @click="delImg"
                  style="position:absolute;right:5px;top:5px;cursor:pointer"
                ></i>
                <!-- el-icon-remove -->
                <img style="width:200px;height:200px" v-if="couponData.img" :src="couponData.img" />
              </div>
              <uploadNew
                ref="commonUpload"
                :type="1"
                :showType="1"
                :multiple="false"
                :showFileList="false"
                :listType="'picture'"
                :buttonName="'选择图片'"
                :tipName="'333x179格式：JPG/PNG'"
                :showImgView="false"
                :limitSize="true"
                :limitWH="333"
                :limitSizeValue="20971520"
                v-on:success="successUploadImg"
              ></uploadNew>
            </el-form-item>
            <el-form-item label="排序">
              <el-col :span="10" class="mr10">
                <el-input v-model="couponData.sort" @keyup.native="checkNumber('sort')"></el-input>
              </el-col>
              <el-col :span="10">数字越小越靠前</el-col>
            </el-form-item>
            <!-- <el-form-item label="使用门店id" v-if="type==='2'" prop="shop_id">
              <el-col :span="10">
                <el-input
                  type="textarea"
                  placeholder="请输入门店id，用逗号隔开"
                  :rows="5"
                  v-model="couponData.shop_id"
                ></el-input>
              </el-col>
            </el-form-item>-->
            <el-form-item label="兑换说明" prop="description">
              <el-col :span="10">
                <el-input type="textarea" :rows="5" v-model="couponData.description"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item>
              <el-button v-if="canSave" type="primary" @click="saveCoupon">保存</el-button>
              <el-button v-else type="primary">保存</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import { couponApi } from "@/api/coupon";
import uploadNew from "@/components/common/upload/indexNew";
export default {
  components: { uploadNew },
  data() {
    return {
      type: "1",
      id: "",
      couponData: {
        name: "",
        denomination: "",
        score: "",
        valid_day: "",
        description: "",
        sort: "",
        coupon_type: "",
        img: ""
      },
      rules: {
        name: [
          { required: true, message: "请填写优惠券名称", trigger: "blur" }
        ],
        denomination: [
          { required: true, message: "请填写优惠券面额", trigger: "blur" }
        ],
        score: [
          { required: true, message: "请填写兑换所需积分", trigger: "blur" }
        ],
        valid_day: [
          { required: true, message: "请填写有效期", trigger: "blur" }
        ],
        description: [
          { required: true, message: "请填写兑换说明", trigger: "blur" }
        ]
      },
      editdata: {},
      canSave: true,
      curpage: ""
    };
  },
  mounted() {
    this.initData();
  },

  methods: {
    initData() {
      this.id =
        this.$route.params && this.$route.params.id
          ? this.$route.params.id.split("_")[0]
          : "";
      this.curpage =
        this.$route.params && this.$route.params.id
          ? this.$route.params.id.split("_")[1]
          : "";
      if (this.id) {
        this.getCouponDetail();
      }
    },
    /**
     * 获取优惠券详情
     */
    getCouponDetail() {
      this.$EpetJs.Common.get(
        couponApi.getGeneralCouponUrl + "/" + this.id
      ).then(res => {
        this.editdata = res.data.data;
        this.type = res.data.data.coupon_type.toString();
        this.couponData = {
          name: this.editdata.name,
          denomination: this.editdata.denomination,
          score: this.editdata.score,
          valid_day: this.editdata.valid_day,
          description: this.editdata.description,
          sort: this.editdata.sort,
          coupon_type: this.editdata.coupon_type,
          img: this.editdata.img
        };
        // this.couponData = res.data.data;
      });
    },
    /**
     * 检测数字
     */
    checkNumber(dataName) {
      let value = this.couponData[dataName];
      value = value.replace(/[^\d]/g, "");
      value = value.replace(/^(0)*(\d+)*$/, "$2");
      this.couponData[dataName] = value;
    },
    typeChange(val) {
      if (!this.id) {
        this.$refs["couponForm"].resetFields();
      }
      if (this.editdata.coupon_type != parseInt(val)) {
        this.couponData = {
          name: "",
          denomination: "",
          score: "",
          valid_day: "",
          description: "",
          sort: "",
          coupon_type: "",
          img: ""
        };
      } else {
        this.couponData = {
          name: this.editdata.name,
          denomination: this.editdata.denomination,
          score: this.editdata.score,
          valid_day: this.editdata.valid_day,
          description: this.editdata.description,
          sort: this.editdata.sort,
          coupon_type: this.editdata.coupon_type,
          img: this.editdata.img
        };
        // this.couponData = this.editdata;
      }
    },
    /**
     * 保存优惠券
     */
    saveCoupon() {
      if (!this.canSave) {
        return;
      }
      this.canSave = false;
      this.$refs.couponForm.validate(valid => {
        if (valid) {
          this.couponData.coupon_type = this.type;
          if (this.id === "") {
            //新增
            this.$EpetJs.Common.post(
              couponApi.addGeneralCoupon,
              this.couponData
            ).then(res => {
              if (res) {
                this.canSave = true;
                this.$message.success("保存成功！");
                this.$router.replace("/coupon/general");
                this.initData();
              }
            });
          } else {
            // 编辑
            this.$EpetJs.Common.put(
              couponApi.editGeneralCoupon + "/" + this.id,
              this.couponData
            ).then(res => {
              if (res) {
                this.canSave = true;
                this.$message.success("保存成功！");
                let pam = this.id + "_" + this.curpage;
                this.$router.push({
                  path: "/coupon/general",
                  query: {
                    str: pam
                  }
                });
                this.initData();
              }
            });
          }
        }
      });
    },
    /**
     *  上传图片
     * @param {d} data
     */
    successUploadImg(data) {
      console.log(data.Location);
      this.couponData.img = data.Location;
    },
    /**
     * 删除图片
     */
    delImg() {
      this.couponData.img = "";
    }
  },
  watch: {
    $route(to, from) {
      if (to.name == "coupon_add" || to.name == "coupon_edit") {
        this.initData();
      }
    }
  }
};
</script>

<style scoped>
.coupon-edit-body {
  min-height: calc(100vh - 60px);
}
</style>